import { Box } from "@mui/material"

export const WhatIsSH = () => {
    return <>
        <Box className="WELCOME_slide">
            <Box className="WELCOME_about">
                <Box>
                    <h1>What Is SmoothHiring</h1>
                </Box>
            </Box>
        </Box>
    </>
}